<p-confirmDialog></p-confirmDialog>

<h3 class="with-manual-link">
  <span i18n="@@fusion-bot">Fusion-View</span>
  <app-manual-link
    href="/Handbuch/Nutzeroberfläche/Bot-Verwaltung/Allgemein/Konfiguration/Fusion-View"></app-manual-link>
</h3>

<p
  class="text-secondary mt-1 mb-1"
  i18n="@@fusionview-description"
>
  In diesem Tab kannst du diverse Fusion-Views erstellen, um den Bot mit verschiedenen Inhalten zu verbinden.
</p>

<!-- ===== INLINE GRID (wenn noch keine Fusion-Views vorhanden) ===== -->
@if (this.fusionService.fusionContent.length === 0) {
<p
  class="text-secondary mb-2"
  i18n="@@fusion-choose-type"
>Wähle einen Typ, um deine erste Fusion-View zu erstellen:</p>
<div class="type-grid">
  @for (t of this.getTypes(); track t) {
  <div
    class="type-card"
    (click)="this.selectTypeAndCreate(t)"
  >
    @if (this.typeInfo[t]?.img) {
    <img
      [src]="this.typeInfo[t]?.img"
      class="type-card-img"
      [alt]="capitalizeOrParse(t)"
    >
    }
    @if (this.typeInfo[t]?.icon) {
    <i [class]="this.typeInfo[t]?.icon + ' type-card-icon'"></i>
    }
    <span class="type-card-name">{{ capitalizeOrParse(t) }}</span>
    <span class="type-card-desc">{{ this.typeInfo[t]?.desc }}</span>
  </div>
  }
</div>
}

<!-- ===== TABELLE + BUTTON (wenn Fusion-Views vorhanden) ===== -->
@if (this.fusionService.fusionContent.length > 0) {
<div class="mb-3">
  <p-button
    size="small"
    icon="ri-add-line"
    (onClick)="this.openCreateDialog()"
    i18n-label="@@add-fusion-view"
    label="Neue Fusion-View erstellen"
  ></p-button>
</div>
@if (bulkFailedNames) {
<p class="bot-bulk-error" role="alert"><span i18n="@@fusionview-bulk-failed">Folgende Fusion-Views konnten nicht gelöscht werden. Versuche es erneut:</span> {{bulkFailedNames}}</p>
}
<p-table
  [value]="this.fusionService.fusionContent"
  dataKey="_id"
  [(selection)]="selectedFusionContents"
  [rowHover]="true"
  (onRowReorder)="this.onRowReorder($event)"
  styleClass="p-datatable-sm"
>
  <ng-template pTemplate="header">
    <tr>
      <th style="width: 2.5rem;"></th>
      <th class="bot-selection-cell"><p-tableHeaderCheckbox [disabled]="bulkBusy"
        ariaLabel="Alle Fusion-Views auswählen" i18n-ariaLabel="@@fusionview-select-all" /></th>
      <th i18n="@@type">Typ</th>
      <th i18n="@@title">Titel</th>
      <th i18n="@@fusion-view-name">Identifikator</th>
      <th i18n="@@actions">Aktionen</th>
    </tr>
  </ng-template>
  <ng-template
    pTemplate="body"
    let-fusionContent
    let-index="rowIndex"
  >
    <tr [pReorderableRow]="index">
      <td>
        <i
          class="ri-draggable drag-handle"
          pReorderableRowHandle
        ></i>
      </td>
      <td class="bot-selection-cell"><p-tableCheckbox [value]="fusionContent" [disabled]="bulkBusy"
        [ariaLabel]="fusionContent.metadata.title" /></td>
      <td style="width: 32px;">
        <img
          src="assets/iframely/{{fusionContent.metadata.type.replace('iframely_','')}}.png"
          alt="{{fusionContent.metadata.type}}"
          class="logo-icon"
        >
      </td>
      <td>
        <input
          pInputText
          pSize="small"
          type="text"
          [(ngModel)]="fusionContent.metadata.title"
          [ngModelOptions]="{ updateOn: 'blur' }"
          (ngModelChange)="this.fusionService.updateFusionFieldFor(fusionContent._id, 'title', fusionContent.metadata.title)"
          class="p-inputtext-sm w-100 title-inline-edit"
        >
      </td>
      <td>
        {{ fusionContent.metadata.name }}
      </td>
      <td
        style="width: 2rem;"
        class="text-end"
      >
        <p-menu
          #menu
          [model]="this.getFusionActionMenuItems(fusionContent)"
          [popup]="true"
          appendTo="body"
        ></p-menu>
        <p-button
          [rounded]="true"
          severity="secondary"
          icon="ri ri-more-2-fill"
          styleClass="button-icon"
          (onClick)="menu.toggle($event)"
        ></p-button>
      </td>
    </tr>
  </ng-template>
</p-table>
<app-bulk-action-bar [actions]="bulkActions" [count]="selectedFusionContents.length" [busy]="bulkBusy"
  [allSelected]="selectedFusionContents.length === this.fusionService.fusionContent.length"
  (selectAll)="selectedFusionContents = this.fusionService.fusionContent.slice()" (clear)="selectedFusionContents = []" />
}

<!-- ===== STEP 1: TYP-AUSWAHL DIALOG ===== -->
<p-dialog
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [(visible)]="this.showCreateDialog"
  i18n-header="@@choose-fusion-type"
  header="Typ auswählen"
  [style]="{ width: '640px' }"
>
  <!-- Filter -->
  <div class="mb-3">
    <span class="p-input-icon-left w-100">
      <i class="ri-search-line"></i>
      <input
        pInputText
        class="w-100"
        type="text"
        i18n-placeholder="@@filter-types"
        placeholder="Typen filtern…"
        [(ngModel)]="this.typeFilter"
      >
    </span>
  </div>

  <!-- Typ-Grid -->
  <div class="type-grid">
    @for (t of this.getFilteredTypes(); track t) {
    <div
      class="type-card"
      (click)="this.selectType(t)"
    >
      @if (this.typeInfo[t]?.img) {
      <img
        [src]="this.typeInfo[t]?.img"
        class="type-card-img"
        [alt]="capitalizeOrParse(t)"
      >
      }
      @if (this.typeInfo[t]?.icon) {
      <i [class]="this.typeInfo[t]?.icon + ' type-card-icon'"></i>
      }
      <span class="type-card-name">{{ capitalizeOrParse(t) }}</span>
      <span class="type-card-desc">{{ this.typeInfo[t]?.desc }}</span>
    </div>
    }
  </div>
</p-dialog>

<!-- ===== STEP 2: TITEL-EINGABE DIALOG ===== -->
<p-dialog
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [(visible)]="this.showTitleDialog"
  i18n-header="@@fusion-title-heading"
  header="Titel vergeben"
  [style]="{ width: '440px' }"
>
  <div class="d-flex align-items-center mb-3">
    @if (this.typeInfo[this.type]?.img) {
    <img
      [src]="this.typeInfo[this.type]?.img"
      class="type-card-img me-2"
      [alt]="capitalizeOrParse(this.type)"
    >
    }
    @if (this.typeInfo[this.type]?.icon) {
    <i [class]="this.typeInfo[this.type]?.icon + ' type-card-icon me-2'"></i>
    }
    <span class="fw-semibold">{{ capitalizeOrParse(this.type) }}</span>
  </div>

  <div class="mb-2">
    <label
      class="form-label fw-semibold"
      for="newFusionTitle"
      i18n="@@title"
    >Titel</label>
    <input
      pInputText
      id="newFusionTitle"
      class="w-100"
      type="text"
      i18n-placeholder="@@describe-fusion-view-title"
      placeholder="Titel der Fusion-View"
      [(ngModel)]="this.title"
      (keyup.enter)="this.title.trim() && this.createFusion()"
    >
  </div>

  <ng-template pTemplate="footer">
    <p-button
      size="small"
      severity="secondary"
      [text]="true"
      (onClick)="this.backToTypeSelection()"
      i18n-label="@@back"
      label="Zurück"
    ></p-button>
    <p-button
      size="small"
      icon="ri-add-line"
      [disabled]="!this.title.trim()"
      (onClick)="this.createFusion()"
      i18n-label="@@create"
      label="Erstellen"
    ></p-button>
  </ng-template>
</p-dialog>

<!-- ===== DRAWER: FUSION-VIEW BEARBEITEN ===== -->

<p-drawer
  [(visible)]="this.showDrawer"
  appendTo="body"
  [position]="'right'"
  [modal]="true"
  [closeOnEscape]="true"
  styleClass="w-100 w-md-75 w-lg-50"
>
  <ng-template #header>
    @if (this.fusionService.selectedFusionContent) {
    <div class="d-flex align-items-center gap-2 w-100">
      <!-- HIER NIEMALS DEN FUSION VIEW NAME REIN EINTRAGEN auchnicht den type -->
      <p-button
        size="small"
        severity="primary"
        icon="ri-external-link-line"
        i18n-label="@@open-fusion-view"
        label="Vorschau (Fusion View)"
        class="ms-auto"
        (onClick)="this.openFusionPreview()"
      />
    </div>
    }
  </ng-template>

  @if (this.fusionService.selectedFusionContent) {
  <app-fusion-bot-detatail [hideHeader]="true"></app-fusion-bot-detatail>
  }
</p-drawer>